import createMuiTheme, { Theme } from '@material-ui/core/styles/createMuiTheme';
import { BTCSSecondaryColor } from './constants';
import { paletteLight } from './palette-light';
import { baseMUITheme } from './theme';
import { typography } from './typography';

// any because of themename..
export const themeLight: Theme = (createMuiTheme as any)({
  themeName: 'Light Theme',
  // spread base-theme into the lighter version
  ...baseMUITheme,

  // typo
  typography: typography(paletteLight),

  // palette
  palette: paletteLight,

  overrides: {
    ...baseMUITheme.overrides,
    MuiButton: {
      ...(baseMUITheme.overrides as any).MuiButton,
      containedPrimary: {
        '&:hover': {
          backgroundColor: BTCSSecondaryColor,
        },
      },
      containedSecondary: {
        backgroundColor: '#EEEEEE',
        color: '#262626',
        '&:hover': {
          backgroundColor: '#DDDDDD',
        },
      },
    },
  },
});
